import { IUserSlim } from './user.model';

export enum TradeStatusesEnum {
  // Pending   = 'pending',
  Opened    = 'opened',
  Closed    = 'closed',
  Payment   = 'payment',
  Completed = 'completed',
  Cancelled = 'cancelled'
}

export const tradeStatusLabelMapping = {
  [TradeStatusesEnum.Opened] : 'success',
  [TradeStatusesEnum.Closed]: 'muted',
  [TradeStatusesEnum.Payment]: 'warning',
  [TradeStatusesEnum.Completed]: 'primary',
  [TradeStatusesEnum.Cancelled]: 'error'
};

export type TradeStatus =
  // TradeStatusesEnum.Pending |
  TradeStatusesEnum.Opened |
  TradeStatusesEnum.Closed |
  TradeStatusesEnum.Payment |
  TradeStatusesEnum.Completed |
  TradeStatusesEnum.Cancelled;

export enum TradeTypesEnum {
  Usual    = 'usual',
  Bonus    = 'bonus'
}

export const tradeTypeLabelMapping = {
  [TradeTypesEnum.Usual] : 'usual',
  [TradeTypesEnum.Bonus]: 'bonus'
};

export type TradeType =
  TradeTypesEnum.Usual |
  TradeTypesEnum.Bonus;

interface ITradeBase {
  id: number;
  blockSize: number;
  blockValue: number;
  startDate: string;
  endDate: string;
  daysLeft: number;
  status: TradeStatus;
  type: TradeType;
}

export interface ITrade extends ITradeBase {
  blocksTotal: number;
  blocksSold: number;
  userGains: IUserSlim[];
  userBlocksBalance: number;
}

export interface ITradeSlim extends ITradeBase {
  noOfUsers: number;
}

export interface ITradeSubmit {
  blockSize: number;
  blockValue: number;
  blocksTotal: number;
  blocksSold: number;
  endDate: string;
}

export interface ITradeSubmitWithFile {
  trade: ITradeSubmit;
  dataBase64: string;
  // Optional list of existing partner (user) IDs to invite
  partnerIds?: number[];
}

export interface IBonusTradeSubmit {
  certificateValue: number;
  certificatesTotal: number;
  endDate: string;
}

export interface IBonusTradeSubmitWithFile {
  trade: IBonusTradeSubmit;
  dataBase64: string;
  // Optional list of existing partner (user) IDs to invite
  partnerIds?: number[];
}

export enum TradeCommentTypesEnum {
  User = 'user',
  System  = 'system'
}

export type TradeCommentType =
  TradeCommentTypesEnum.User |
  TradeCommentTypesEnum.System;

export interface ITradeComment {
  id: number;
  tradeId: number;
  user: IUserSlim;
  type: TradeCommentType;
  createdDate: string;
  value: string;
}

export interface ITradeCommentSubmit {
  text: string;
}

export interface ITradeCreationResult {
  success: boolean;
  failCause: TradeImportFailCauseEnum;
  skippedCount: number;
  trade: ITradeSlim;
}


export interface IImportTradeUsersResult {
  success: boolean;
  failCause: TradeImportFailCauseEnum;
  skippedCount: number;

}

export enum TradeImportFailCauseEnum {
  EmptyCause,
  WrongFileType,
  WrongColumnNames,
  WrongData,
  TradeNotFound,
}
